import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { basketSelectors } from '@store/basket/selectors';
import { entitySelectors } from '@store/entity';
import { PersonalisationMessage } from './PersonalisationMessage';
import { createBasket, updateBasket } from '@store/basket/actions';

const { getProperty } = entitySelectors;

const mapStateToProps = (state) => {
  const property = getProperty(state);

  const { eventSettings, voucherSettings } = property;

  return {
    basketDetails: basketSelectors.getBasketDetails(state),
    isBasketDetailsFetching: basketSelectors.getIsBasketDetailsFetching(state),
    hasDefaultEVoucher: !!voucherSettings?.defaultEVoucher,
    hasDefaultOverprint: !!voucherSettings?.defaultOverprint,
    hasDefaultETicket: !!eventSettings?.defaultEVoucher,
    hasDefaultTicketOverprint: !!eventSettings?.defaultOverprint,
    property,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      createBasket,
      updateBasket,
    },
    dispatch
  );

export const PersonalisationMessageConnected = connect(
  mapStateToProps,
  mapDispatchToProps
  // @ts-ignore Pre-existing type mismatch between createBasket action and component prop types
)(PersonalisationMessage);
